__webpack_require__.p = "/industry/";